<template>
    <div class="home">
          <div class="box content">	
            <h1 class="title">Statement of Eligibility to Work (Health Care Workers)</h1>

            <div v-if="loading==false">
                <div class="notification is-danger content" v-if="member.enabled==0">
                    This request has expired. Please check your email for a more recent message or contact Balmoral to send the request again.
                </div>
                <div class="notification is-danger content" v-if="member.expired==1">
                    This request has expired. Please check your email for a more recent message or contact Balmoral to send the request again.
                </div>
                <div class="notification is-success content" v-else-if="member.confirmed==1">
                    <span v-if="member.newly_confirmed==1">
                        Thank you. Your eligibility has now been updated in our system.
                    </span>
                    <span v-else>
                        This request has already been confirmed.
                    </span>
                </div>

                <form @submit.prevent="saveEligibility" v-if="member.enabled ==1 && member.expired==0 && member.confirmed==0">
                      
                      <p>
                        I confirm that I understand my obligations as a health care worker, and I undertake to comply with any guidance issued by any regulatory or professional body relevant to my post. I am aware that I must not allow my own health condition to endanger patients. I also confirm that I am not aware of having any medical disorder which would in any way restrict my clinical practice (including exposure prone procedures) or place patients at risk.
                        </p>
                        <p>
                        If I have travelled to a high risk country for a period of 4 weeks or more in the last 5 years I can confirm that I have had appropriate TB follow up screening.
                        </p>
                        <p>

                        I confirm I have not been the subject of any issues of concern or investigations of any form regarding my clinical performance.
                      </p>
                      <div class="field is-grouped">
                          <div class="control">
                              <button class="button is-success" :disabled="loading===true">I Confirm All Of the Above is Correct</button>
                          </div>
                      </div>
                  </form>

            </div>
              

            <div class="notification is-warning content" v-if="loading==true">
                Loading details ...
            </div>
            
          </div>
          
      </div>
  </template>

<script>
    import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'AddOrganisation',
        mixins: [],
        data: function () {
            return {
                member_code : this.$route.params.id,
                   loading : true,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    name: '',
                    member: [],
                    system_title : process.env.VUE_APP_SYSTEM_TITLE,
                    
                   
            }
        },
        created() {
          this.getEligibility()
         
        },
        methods: {
           
            async saveEligibility() {
                if(confirm('Are you sure you have read all of the conditions correctly and wish to confirm your Eligibility to Work with ? ' + this.system_title))
                {
                    this.loading = true;
                    UtilityService.postSimpleApiData(this.accessToken, "web/eligibility/" + this.member_code + '/confirm').then(
                        response => {
                            this.member = response 
                            this.loading = false;
                        }
                    );
                }
            },
            
            async getEligibility() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "web/eligibility/" + this.member_code).then(
                    response => {
                        this.member = response 
                        this.loading = false;
                    }
                );
            },
            
           
        }
    }
    </script>